import {AppApiService} from "./app-api.service";
import {ExerciseDetails} from "../models/interfaces/exercise-details.interface";
import {ExerciseSearchResponseDto} from "../models/interfaces/exercise-search-response-dto.interface";

class ExerciseApiService extends AppApiService {
    public async getExerciseById(id: string): Promise<ExerciseDetails> {
        return await this.get<ExerciseDetails>(`/exercise/${id}`, {
            errorMessage: "Błąd podczas pobierania ćwiczenia",
        }).catch((error) => {
            throw error;
        });
    }

    public async searchExercises(filter: string = "", limit: number = 20, offset: number = 0): Promise<ExerciseSearchResponseDto> {
        return await this.get<ExerciseSearchResponseDto>(`/exercise/search`, {
            params: {filter, limit, offset},
            errorMessage: "Błąd podczas wyszukiwania ćwiczeń",
        }).catch((error) => {
            throw error;
        });
    }
}

export default new ExerciseApiService();

